const CDN_BASE = 'https://pics.avs.io';
const CDN_SIZE = '64/64'; // width/height segment

function normalize(input: string): string {
  return input.trim().toUpperCase();
}

export function getAirlineLogoUrl(iata: string): string {
  if (!iata) {
    return '/airlines/placeholder.svg';
  }
  return `${CDN_BASE}/${CDN_SIZE}/${normalize(iata)}.png`;
}
